import { graphql, useFragment } from "react-relay";
import { StoreFormattedDate$key } from "./__generated__/StoreFormattedDate.graphql";

export function StoreFormattedDate(props: { date: StoreFormattedDate$key }) {
  const date = useFragment(
    graphql`
      fragment StoreFormattedDate on StoreZonedDate
      @argumentDefinitions(
        style: { type: "FormattedDateStyle", defaultValue: DEFAULT }
      ) {
        storeFormattedDate(style: $style)
      }
    `,
    props.date
  );

  return date.storeFormattedDate;
}
